import React, { useEffect, useState, Dispatch, SetStateAction } from 'react';

import ColorPicker from '../ColorPicker';
import { TableRow, TableCell, Checkbox } from '@material-ui/core';
import ItemComboBox, { ComboBoxItemType } from '../../../atoms/ComboBox/ItemComboBox';
import { MeasureHighKind, AlmTypKind, SpeedKind, PARTIAL_DISCHARGE_PLCNO, CcTypKind } from '../../../../Constant';

import { MST_CLC_TYPE } from '../../MeasureSetting/JudgeSetting/JudgeSetting';
import { SET_PART_DIS } from '../../MeasureSetting/PartialDischargeCollection/PartialDischargeCollection';

import { JudgeInfo, V_TREND_SETTING_ITEM, KIND_NO_NAME_SET, ColSetInfo } from '../../../../function/GroupDataModel';
import { JudgeSettingSelectType, GetJudgeSettingSelectItems } from '../../../../function/JudgeSettingSelectModel';
import { ALM_KIND_SET } from '../../../../function/AlmKindSetModel';
import { IsConanAirPlc, IsPartialDischargePlc } from '../../../../function/PlcNoModel';

import { GetLimit, GetUnit, CLC_TYP_SET } from './TrendSetting';
import { TableBaseStyle, TrendSettingStyle } from './TrendSettingStyle';


type TrendSettingItemProps = {
  rowno: number;
  selectIdx: number;
  setSelectIdx: Dispatch<SetStateAction<number>>;
  item: V_TREND_SETTING_ITEM;
  updateItem: (item: V_TREND_SETTING_ITEM) => void;
  measKinds: ComboBoxItemType[];
  deviceLists: ComboBoxItemType[];
  itemLists: ComboBoxItemType[];
  dataKinds: ComboBoxItemType[];
  alarmKinds: ComboBoxItemType[];
  alarmLimits: JudgeInfo[];
  //deviceUnitInfos: PlcInfo[];
  colSetInfos: ColSetInfo[];
  kindNoNameSets: KIND_NO_NAME_SET[];
  judgeSetSelect: JudgeSettingSelectType[];
  mClcTypes: ComboBoxItemType[];
  setPartDis: SET_PART_DIS[];
};

/**
 * 計測種別のアイテム選択
 * @param item 
 * @param nameSets 
 * @returns 
 */
const getKindIndex = (item: V_TREND_SETTING_ITEM, nameSets: KIND_NO_NAME_SET[]): number => {
  var index = nameSets.findIndex((r) => r.SPEED == item.SPEED && r.NAME_NO == item.KIND_NO);
  //console.debug(['item,nameSets,index', item, nameSets, index]);
  return index;
};

const TrendSettingItem: React.FC<TrendSettingItemProps> = (props: TrendSettingItemProps) => {
  const tableStyle = TableBaseStyle();
  const pageStyle = TrendSettingStyle();

  const limit = GetLimit(
    props.alarmLimits,
    props.item.PLC_NO,
    props.item.AI_CARD,
    props.item.AI_CH,
    props.item.CLC,
    props.item.TYP_NO,
    props.item.KIND_NO,
    props.item.MCLC_TYP_ID
  );

  //console.debug(['GetLimit', props.item, limit]);
  //const unit = props.item.EMC_UNIT ?? props.item.UNIT;
  const unit = GetUnit(
    props.colSetInfos,
    props.item.PLC_NO,
    props.item.AI_CARD,
    props.item.AI_CH,
    props.item.CLC,
    props.item.KIND_NO
  );
  /**
   * 計測種別アイテム種痘
   * @returns
   */
  const measFilterCombos = (): ComboBoxItemType[] => {
    //console.debug(['計測種別アイテム取得', props.judgeSetSelect, props.measKinds]);
    return props.measKinds.filter((r) => {
      let v = r.tag as KIND_NO_NAME_SET;
      if (r.index === 0 || v == null) {
        //console.debug(['計測種別アイテム取得2', r, v]);
        return true;
      }
      if (props.judgeSetSelect.findIndex((row) => row.SPEED === v.SPEED && row.NAME_NO === v.NAME_NO) !== -1) {
        //console.debug(['計測種別アイテム取得3', r, v]);
        return true;
      }
      return false;
    });
  };

  /**
   * 項目種別アイテム種痘
   * @returns
   */
  const itemListFilterCombos = (): ComboBoxItemType[] => {
    let findCols = props.colSetInfos.filter(
      (csi) =>
        IsConanAirPlc(String(csi.PLC_NO)) === false &&
        csi.DEV_INDEX === props.item.DEV_INDEX &&
        csi.SPEED === props.item.SPEED &&
        csi.KIND_NO === props.item.KIND_NO
    );
    let findCols2 = props.colSetInfos.filter(
      (csi) =>
        IsConanAirPlc(String(csi.PLC_NO)) === true &&
        csi.DEV_INDEX === props.item.DEV_INDEX &&
        csi.SPEED === props.item.SPEED
    );
    //部分放電の項目名称取得
    let findPartialDischarge = props.kindNoNameSets.filter(
      (kns) =>
        kns.SPEED === props.item.SPEED &&
        kns.SPEED === 7 &&
        kns.NAME_NO === props.item.KIND_NO
    )

    findCols = findCols.concat(findCols2);

    console.debug(['itemListFilterCombos', props, findCols, findPartialDischarge]);
    return props.itemLists.filter((r) => {
      if (r.index === 0) {
        return true;
      }
      if (findCols.findIndex((row) => row.ITM_NAME_NO === r.index) !== -1) {
        return true;
      }
      if (findPartialDischarge.findIndex((row) => row.MES_NAME === r.name) !== -1) {
        return true;
      }
      return false;
    });
  };

  /**
   *データ種別
   * @returns
   */
  const createDataKindCombos = (): ComboBoxItemType[] => {
    //console.debug(['データ種別選択候補リスト情報', props.item, props.dataKinds]);
    if (props.item.KIND_NO === MeasureHighKind.VIBRATION_SPD || props.item.KIND_NO === MeasureHighKind.VIBRATION_DSP) {
      //console.debug('VIBRATION_SPD');
      if (props.item.CLC !== 4) {
        props.item.CLC = 4;
        props.updateItem(props.item);
      }
      return props.dataKinds.filter((r) => r.index === 4);
    }

    return props.dataKinds.filter((r) => {
      let v = r.tag as CLC_TYP_SET;
      let item = props.item;

      if (r.index === 0 || v == null) {
        return true;
      }
      if (v.TYP_NO !== CcTypKind.MOVE_AVERAGE) {  //移動平均非表示
        if (
          props.judgeSetSelect.findIndex(
            (row) => row.SPEED === item.SPEED && row.NAME_NO === item.KIND_NO && row.TYP_NO_CLC === v.TYP_NO
          ) !== -1
        ) {
          return true;
        }
        return false;
      }

    });
  };

  /**
   *演算種別
   * @returns
   */
  const createMclcCombos = (): ComboBoxItemType[] => {
    console.debug(['演算種別選択候補リスト情報', props.item, props.mClcTypes]);
    if (props.item.KIND_NO === MeasureHighKind.VIBRATION_SPD || props.item.KIND_NO === MeasureHighKind.VIBRATION_DSP) {
      return props.mClcTypes.filter((r) => {
        let v = r.tag as MST_CLC_TYPE;
        if (r.index === 0 || v == null) {
          return true;
        }
        if (props.item.KIND_NO === MeasureHighKind.VIBRATION_SPD && r.index === AlmTypKind.eRawSpd) {
          return true;
        }
        if (props.item.KIND_NO === MeasureHighKind.VIBRATION_DSP && r.index === AlmTypKind.eRawDsp) {
          return true;
        }
        return false;
      });
    } else {
      return props.mClcTypes.filter((r) => {
        let v = r.tag as MST_CLC_TYPE;
        let item = props.item;

        if (r.index === 0 || v == null) {
          return true;
        }
        if (
          props.judgeSetSelect.findIndex(
            (row) =>
              row.SPEED === item.SPEED &&
              row.NAME_NO === item.KIND_NO &&
              row.TYP_NO_CLC === item.CLC &&
              row.MCLC_TYP_ID === v.MCLC_TYP_ID
          ) !== -1
        ) {
          return true;
        }
        return false;
      });
    }
  };
  /**
   *異常種別
   * @returns
   */
  const createAlarmKindCombos = (): ComboBoxItemType[] => {
    //console.debug(['異常種別候補リスト', props.item, props.alarmKinds]);
    return props.alarmKinds.filter((r) => {
      let v = r.tag as ALM_KIND_SET;
      let item = props.item;
      if (r.index === 0 || v.MCLC_TYP_ID === item.MCLC_TYP_ID) {
        return true;
      }
      return false;
    });
  };

  const selectRow = () => {
    props.setSelectIdx(props.rowno);
  };

  /**
   * 警報閾値 軽故障
   * @returns 
   */
  const CreateLFaultValue = (): string => {
    //console.debug(["test", props.item]);
    if (IsPartialDischargePlc(String(props.item.PLC_NO))) {
      let data = props.setPartDis.find((row) => row.DEV_INDEX === props.item.DEV_INDEX);
      if (props.item.CLC === CcTypKind.PD_TYP_NO_CLC_MAXVALUE && data?.LMT_L !== undefined) {
        return data.LMT_L !== null ? data.LMT_L.toFixed(4) : '';
      }
      else if (props.item.CLC === CcTypKind.PD_TYP_NO_CLC_PDVALUE && data?.LMT_L_PD !== undefined) {
        return data.LMT_L_PD !== null ? data.LMT_L_PD.toFixed(4) : '';
      }
      else {
        return '';
      }
    }
    else {
      return limit?.WRN_LIM.toFixed(4) ?? '';
    }
  };

  /**
   * 
   * @returns 警報閾値 重故障
   */
  const CreateHFaultValue = (): string => {
    if (IsPartialDischargePlc(String(props.item.PLC_NO))) {
      let data = props.setPartDis.find((row) => row.DEV_INDEX === props.item.DEV_INDEX);
      if (props.item.CLC === CcTypKind.PD_TYP_NO_CLC_MAXVALUE && data?.LMT_H !== undefined) {
        return data.LMT_H !== null ? data.LMT_H.toFixed(4) : '';
      }
      else if (props.item.CLC === CcTypKind.PD_TYP_NO_CLC_PDVALUE && data?.LMT_H_PD !== undefined) {
        return data.LMT_H_PD !== null ? data.LMT_H_PD.toFixed(4) : '';
      }
      else {
        return '';
      }
    }
    else {
      return limit?.ALM_LIM.toFixed(4) ?? '';
    }
  }

  return (
    <TableRow className={props.rowno == props.selectIdx ? pageStyle.activeRow : ''}>
      {/**表示有 */}
      <TableCell className={tableStyle.bodyCell} width={'40px'} onClick={(e) => selectRow()}>
        <Checkbox
          checked={props.item.DSP_FLG == 1}
          onChange={(e) => {
            props.item.DSP_FLG = e.target.checked ? 1 : 0;
            props.updateItem(props.item);
          }}
        />
      </TableCell>
      {/**表示線 */}
      <TableCell className={tableStyle.bodyCell} width={'40px'} onClick={(e) => selectRow()}>
        <ColorPicker
          color={props.item.DSP_COLOR}
          setColor={(col) => {
            props.item.DSP_COLOR = col;
            props.updateItem(props.item);
          }}
        />
      </TableCell>
      {/**計測種別 */}
      <TableCell className={tableStyle.bodyCellCenter} width={'250px'} onClick={(e) => selectRow()}>
        <ItemComboBox
          itemList={measFilterCombos()}
          label=""
          value={getKindIndex(props.item, props.kindNoNameSets)}
          onChangeEvent={(e) => {
            if (typeof e.target.value === 'string') {
              var k = props.kindNoNameSets[parseInt(e.target.value)];

              /* 計測種別が空白になった場合チェックを外す */
              /* 計測種別が変更された場合チェックを付ける */
              props.item.SPEED = e.target.value === '0' ? 0 : k.SPEED;
              props.item.KIND_NO = e.target.value === '0' ? 0 : k.NAME_NO;
              props.item.DSP_FLG = e.target.value === '0' ? 0 : 1;
              props.item.DEV_INDEX = e.target.value === '0' ? 0 : props.item.DEV_INDEX;
              props.item.ITM_NAME_NO = 0;
              props.item.TYP_NO = 0;
              props.item.CLC = 0;
              props.item.MCLC_TYP_ID = 0;
              if (k.SPEED === SpeedKind.SPEED_CONAN) {
                //コナンエアの場合SET_NOにKIND_NOを保持
                props.item.SET_NO = k.NAME_NO;
              }
              if (k.SPEED === SpeedKind.SPEED_PARTIALDISCHARGE) {
                //部分放電の場合PLC_NO等をSET
                props.item.PLC_NO = PARTIAL_DISCHARGE_PLCNO;
                props.item.AI_CARD = 1;
                props.item.AI_CH = 1;
              }
              props.updateItem(props.item);
            }
          }}
        />
      </TableCell>
      {/** 機器番号・機器名称*/}
      <TableCell className={tableStyle.bodyCellCenter} width={'180px'} onClick={(e) => selectRow()}>
        <ItemComboBox
          itemList={props.deviceLists}
          label=""
          value={props.item.DEV_INDEX}
          onChangeEvent={(e) => {
            if (typeof e.target.value === 'string') {
              props.item.DEV_INDEX = parseInt(e.target.value);
              props.updateItem(props.item);
            }
            //部分放電の場合SET_NOを登録
            if (props.item.SPEED === SpeedKind.SPEED_PARTIALDISCHARGE) {
              let data = props.setPartDis.find((row) => row.DEV_INDEX === props.item.DEV_INDEX);
              props.item.SET_NO = data !== undefined ? data.SET_NO : 0;
            }
          }}
        />
      </TableCell>
      {/**項目名称 */}
      <TableCell className={tableStyle.bodyCellCenter} onClick={(e) => selectRow()}>
        <ItemComboBox
          itemList={itemListFilterCombos()}
          label=""
          value={props.item.ITM_NAME_NO}
          onChangeEvent={(e) => {
            if (typeof e.target.value === 'string') {
              props.item.ITM_NAME_NO = parseInt(e.target.value);
              props.updateItem(props.item);
            }
          }}
        />
      </TableCell>
      {/* 演算方法 */}
      <TableCell className={tableStyle.bodyCellCenter} onClick={(e) => selectRow()}>
        <ItemComboBox
          itemList={createDataKindCombos()}
          label=""
          value={props.item.CLC}
          onChangeEvent={(e) => {
            if (typeof e.target.value === 'string') {
              props.item.CLC = parseInt(e.target.value);
              props.item.MCLC_TYP_ID = 0;
              props.item.TYP_NO = 0;
              props.updateItem(props.item);
            }
          }}
        />
      </TableCell>
      {/**演算種別 */}
      <TableCell className={tableStyle.bodyCellCenter} width={'250px'} onClick={(e) => selectRow()}>
        <ItemComboBox
          itemList={createMclcCombos()}
          label=""
          value={props.item.MCLC_TYP_ID}
          onChangeEvent={(e) => {
            if (typeof e.target.value === 'string') {
              props.item.MCLC_TYP_ID = parseInt(e.target.value);
              props.item.TYP_NO = 0;
              props.updateItem(props.item);
            }
          }}
        />
      </TableCell>
      {/** 異常内容*/}
      <TableCell className={tableStyle.bodyCellCenter} onClick={(e) => selectRow()}>
        <ItemComboBox
          itemList={createAlarmKindCombos()}
          label=""
          value={props.item.TYP_NO}
          onChangeEvent={(e) => {
            if (typeof e.target.value === 'string') {
              props.item.TYP_NO = parseInt(e.target.value);
              props.updateItem(props.item);
            }
          }}
        />
      </TableCell>
      {/**警報閾値 軽故障 */}
      <TableCell className={tableStyle.bodyCellCenter} onClick={(e) => selectRow()}>
        {CreateLFaultValue()}
      </TableCell>
      {/**警報閾値 重故障 */}
      <TableCell className={tableStyle.bodyCellCenter} onClick={(e) => selectRow()}>
        {CreateHFaultValue()}
      </TableCell>
      {/**単位 */}
      <TableCell className={tableStyle.bodyCellCenter} onClick={(e) => selectRow()}>
        {unit}
      </TableCell>
    </TableRow>
  );
};

export default TrendSettingItem;
